import type { AuthUser } from "@/domain/Auth/domain/models/AuthUser";
import type { AuthRepository } from "@/domain/Auth/domain/repositories/AuthRepository";

import axiosConfig from "@/axiosConfig";

export class HttpAuthRepository implements AuthRepository {
  async login(email: string, password: string) {
    try {
      const response = await axiosConfig.post("/auth/login", { email, password });
      return response.data;
    } catch (error) {
      console.error("Login error:", error);
      throw error;
    }
  }

  async forgotPassword(email: string) {
    try {
      const response = await axiosConfig.post("/auth/reset-password", { email });
      return response.data;
    } catch (error) {
      console.error("Forgot password error:", error);
      throw error;
    }
  }

  async setPassword(token: string, password: string, passwordConfirmation: string) {
    try {
      const response = await axiosConfig.post("/auth/set-password", {
        token,
        password,
        password_confirmation: passwordConfirmation,
      });
      return response.data;
    } catch (error) {
      console.error("Set password error:", error);
      throw error;
    }
  }

  async acceptInvitation(token: string, password: string, passwordConfirmation: string) {
    try {
      const response = await axiosConfig.post(`/auth/invitation/${token}/accept`, {
        token,
        password,
        password_confirmation: passwordConfirmation,
      });
      return response.data;
    } catch (error) {
      console.error("Accept invitation error:", error);
      throw error;
    }
  }

  async getInvitationDetail(token: string) {
    try {
      const response = await axiosConfig.get(`/auth/invitation/${token}`);
      return response.data;
    } catch (error) {
      console.error("Get invitation detail error:", error);
      throw error;
    }
  }

  async getUserData(): Promise<{ data: AuthUser }> {
    try {
      const response = await axiosConfig.get("/profiles/detail");
      return response.data;
    } catch (error) {
      console.error("Get user data error:", error);
      throw error;
    }
  }

  async refreshToken() {
    try {
      const response = await axiosConfig.post("/profiles/refresh-token");
      return response.data;
    } catch (error) {
      console.error("Token refresh failed:", error);
      throw error;
    }
  }
}
